export default {"src":"/_next/static/media/NTNX.fc3838ba.svg","height":18,"width":18};